<template>
  <button
    @click="toggleLock"
    :class="[
      'btn',
      'btn-lock-bidding',
      { locked: isLockedBidding },
      { 'btn-blue': !isLockedBidding },
      { 'btn-blue-outline': isLockedBidding }
    ]">
    {{ btnText }}
    <base-icon v-if="isLockedBidding" icon-name="lock" view-box="0 0 17.721 23.259">
      <lock-icon></lock-icon>
    </base-icon>
    <base-icon v-else icon-name="unlock" view-box="0 0 18 24">
      <unlock-icon></unlock-icon>
    </base-icon>
  </button>
</template>

<script lang="ts" setup>
  import { BaseIcon, LockIcon, UnlockIcon } from "@/components/icons";
  import { computed } from "vue";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { trans } from "@/utils/trans";

  const auctionStore = useAuctionStore();

  const isLockedBidding = computed(() => {
    return auctionStore.isLockedBidding;
  });
  const btnText = computed(() => {
    const isAdmin = auctionStore.user?.is_admin;

    if (isLockedBidding.value) {
      return trans("live.tabs.lock_unlock." + (isAdmin ? "unlock_btn_label" : "buyer_unlock_btn_label"));
    } else {
      return trans("live.tabs.lock_unlock." + (isAdmin ? "lock_btn_label" : "buyer_lock_btn_label"));
    }
  });

  const toggleLock = () => {
    auctionStore.$patch({
      isLockedBidding: !isLockedBidding.value
    });
  };
</script>
